import { useLayoutEffect, useState } from "react";
import { isEmpty } from "lodash";
import logger from "../logger";
import { APPLICATION_ID } from "../utilities";

const useGetGraph = () => {
  const [data, setData] = useState(null);
  const [graphId, setGraphId] = useState(null);
  const [filePath, setFilePath] = useState(null);
  useLayoutEffect(() => {
    const { events, formserverConfigs } = window;
    // load graph via events trigger
    if (events) {
      events.on("loadDynamicForm", ({ data, graphId, filePath }) => {
        setFilePath(filePath);
        setGraphId(graphId);
        setData(data);
      });
    }
    // load graph via function call
    formserverConfigs.initializeForm = (data, graphId, filePath) => {
      if (DataTransferItem) {
        setFilePath(filePath);
        setGraphId(graphId);
        setData(data);
      }
    };

    formserverConfigs.resetForm = () => {
        setFilePath(null);
        setGraphId(null);
        setData(null);
    };

    if (isEmpty(formserverConfigs)) {
      logger.error({
        message: "formserverConfigs missing",
        module: "Formserver",
        fileName: "useGetGraph.js",
        functionName: "useEffect",
        logLevel: "Critical",
        details: "formserverConfigs is not defined or empty",
        parameters: JSON.stringify(formserverConfigs),
        url: window.location.href,
        application: APPLICATION_ID, //TODO: for formserver we need application id
      });
    }
  }, []);

  return { data, graphId, filePath };
};

export default useGetGraph;
